import React, { useState } from "react";
import { Formik } from "formik";
import axios from "axios";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import * as Yup from "yup";
import { Input, message } from "antd";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function ChangePassword() {
  const [initialState, setInitialState] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    oldPassword: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .required("Old password is required"),
    newPassword: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .required("New password is required"),
    confirmPassword: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  return (
    <div className="auth-wrapper">
      <div className="auth-inner">
        <Formik
          initialValues={initialState}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            var url = window.API_PREFIX + "users/api/post/change-password";
            const requestOptions = {
              data: values,
            };
            setLoading(true);
            axios
              .post(url, requestOptions)
              .then((res) => {
                if (res.status === 200 || res.status === 201) {
                  message.success("Password changed successfully");
                }
              })
              .catch((err) => {
                if (err.response.data[0]) {
                  message.error(err.response.data[0]);
                } else {
                  message.error("An error occurred during password change.");
                }
              })
              .finally(() => setLoading(false));
          }}
        >
          {({ handleSubmit, values, setFieldValue, errors, touched }) => (
            <div>
              <h3>Change Password</h3>

              <div className="mb-3">
                <label>Old Password</label>
                <Input.Password
                  placeholder="Enter old password"
                  name="oldPassword"
                  value={values.oldPassword}
                  onChange={(e) => setFieldValue("oldPassword", e.target.value)}
                />
                {errors.oldPassword && touched.oldPassword && (
                  <span style={{ color: "red" }}>{errors.oldPassword}</span>
                )}
              </div>

              <div className="mb-3">
                <label>New Password</label>
                <Input.Password
                  placeholder="Enter new password"
                  name="newPassword"
                  value={values.newPassword}
                  onChange={(e) => setFieldValue("newPassword", e.target.value)}
                />
                {errors.newPassword && touched.newPassword && (
                  <span style={{ color: "red" }}>{errors.newPassword}</span>
                )}
              </div>

              <div className="mb-3">
                <label>Confirm New Password</label>
                <Input.Password
                  placeholder="Confirm new password"
                  name="confirmPassword"
                  value={values.confirmPassword}
                  onChange={(e) =>
                    setFieldValue("confirmPassword", e.target.value)
                  }
                />
                {errors.confirmPassword && touched.confirmPassword && (
                  <span style={{ color: "red" }}>{errors.confirmPassword}</span>
                )}
              </div>

              <div className="d-grid">
                <button type="submit" className="btn" onClick={handleSubmit}>
                  Change Password
                </button>
              </div>
            </div>
          )}
        </Formik>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </div>
  );
}
export default ChangePassword;
